export default "__VITE_ASSET__zP4pvdSX__"